import { Grid, TextField } from "@mui/material";
import { useForm } from "react-hook-form";
import { FormsIds } from "../../Utils/Constants";
import { postData } from "../../Services/postData";
import { endpoints } from "../../Utils/UrlEnum";
import { CRUDContext } from "./PredefinedTable";
import { useContext, useEffect } from "react";
import { updateData } from "../../Services/updateData";

type PredefinedProps = {
  setTriggerReload: React.Dispatch<boolean>;
  setOpen: React.Dispatch<boolean>;
};

export default function Predefined(props: PredefinedProps) {
  const { setTriggerReload, setOpen } = props;
  const tagContext: any = useContext(CRUDContext);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset, // add reset to update form values
  } = useForm({
    defaultValues: {
      name: "",
    },
  });

  // Update form values if tagContext has a name
  useEffect(() => {
    if (tagContext && tagContext.name) {
      reset({ name: tagContext.name });
    }
  }, [tagContext, reset]);

  const onSubmit = (data: any) => {
    if (tagContext && tagContext._id) {
      updateData(`${endpoints.predefined}/${tagContext._id}`, data);
    } else {
      postData(endpoints.predefined, data);
    }
    setTriggerReload(true);
    setOpen(false);
  };

  return (
    <form id={FormsIds.tagForm} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Nume"
            {...register("name", { required: "Nume este obligatoriu" })}
            error={!!errors.name}
            helperText={errors.name?.message}
          />
        </Grid>
      </Grid>
    </form>
  );
}
